import { fetchAccessTokenIfNeeded } from '~/AccessToken';
import { invokeApi } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import logGoogleTagManagerUser from './logGoogleTagManagerUser';

export default function logGoogleTagManagerCurrentUser(): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		if (dispatch(invokeApi((apiClient) => apiClient.loadAccessToken())) === null) {
			logGoogleTagManagerUser(null);
			return;
		}

		try {
			const response = await dispatch(fetchAccessTokenIfNeeded());
			logGoogleTagManagerUser(response.accessToken.user);
		} catch (error) {
			// ignore error - its handled elsewhere
		}
	};
}
